<div class="card card-side w-full bg-white outline">
  <figure class="hidden sm:block">
    <picture>
      <source
        srcset="/assets/logo/sar-portrait-sm.png"
        media="(min-width: 40rem)"
      />
      <source
        srcset="/assets/logo/sar-portrait-md.png"
        media="(min-width: 48rem)"
      />
      <source
        srcset="/assets/logo/sar-portrait-lg.png"
        media="(min-width: 64rem)"
      />

      <img src="/assets/logo/sar-portrait-sm.png" alt="SAR Logo" />
    </picture>
  </figure>
  <div class="card-body">
    <img src="/assets/logo/logo.png" class="my-8 w-48 sm:hidden" />
    <p class="card-title">SAR {{ "common.title" | translate }}</p>
    <form (submit)="login()" [formGroup]="form">
      <input
        type="text"
        class="input input-bordered mb-4 w-full"
        placeholder="E-Mail"
        [formControl]="email"
      />
      <input
        type="password"
        class="input input-bordered mb-4 w-full"
        placeholder="Password"
        [formControl]="password"
      />

      <div>
        <a routerLink="/forgot-password" class="link">{{
          "authentication.login.forgot-password" | translate
        }}</a>
      </div>

      <div class="card-actions justify-end">
        @if (hasLoginError) {
          <p class="text-error">
            {{ "authentication.login.error" | translate }}
          </p>
        }
        <button
          class="btn btn-primary"
          type="submit"
          [disabled]="form.invalid || isLoggingIn"
        >
          @if (isLoggingIn) {
            <span class="loading loading-spinner"></span>
          }
          {{ "authentication.login.login" | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
